import ListHeader from "@/common/components/ListHeader";
import Table from "@/common/components/Table";
import TextField from "@/common/components/TextField";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { BankInstitutionData, BankInstitutionTableItem } from "../../types/bankInstitution";
import { FileBox, Search } from "lucide-react";
import { defaultColumns } from "../../constants/columns.constant";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { useBankInstitutions } from "@/common/hooks/queries/useBankInstitutions";
import { BankingInstitutionTransformer } from "../../services/bankingInstitutionsTransformer";

const BankingInstitutions = () => {
  const { filterParams, setFilterParams } = useFilterParams();

  const [search, setSearch] = useDebounce(filterParams.search || '');

  const {
    data: bankingInstitutions,
    meta,
    isPending: isPendingBankInstitution,
    isLoading: isLoadingBankInstitution,
    error: bankInstitutionError = {} as any,
    refetch: refetchBankInstitution,
  } = useBankInstitutions({
    filters: {
      search: search,
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer<BankInstitutionData[], BankInstitutionTableItem[]>({
      transformer: BankingInstitutionTransformer.tableTransformer()
    }),
  });

  return (
    <div>
      <div className="flex flex-col gap-6">
        <ListHeader
          Icon={<FileBox className="w-10 h-10" strokeWidth={1.5} />}
          title="Instituições Bancárias"
          createButtonText="Novo banco"
          operationKlassToCheckPermission="Admin::BankInstitutions::Create"
          dataTestid="create_bank_institution_button"
          disableCreateButton={isPendingBankInstitution || bankInstitutionError?.status === 403}
        />

        <ErrorMessageWrapper
          className="h-[calc(100vh-128px)]"
          statusCode={bankInstitutionError?.status}
          refetchFunction={refetchBankInstitution}
        >
          <div className="h-[calc(100vh-128px)] flex flex-col gap-6">
            <div className="flex flex-col gap-4">
              <TextField
                LeftIcon={<Search />}
                placeholder="Pesquisar"
                className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
                onChange={(e) => {
                  setSearch((e.target as HTMLInputElement).value);
                  setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value }))
                }}
                value={filterParams.search}
              />
            </div>

            <Table
              columns={defaultColumns}
              isLoadingData={isLoadingBankInstitution}
              page={filterParams.page || 1}
              rows={bankingInstitutions}
              totalPages={meta.total_pages}
              totalCount={meta.total}
              hasPagination
              setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
              rowEmptyValue="--"
            />
          </div>
        </ErrorMessageWrapper>
      </div>
    </div>
  );
};

export default BankingInstitutions;
